<template>
    <!-- Modal -->
    <div class="modal fade" id="assignRiderModal" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="assignRiderLabel">Assign Rider </h4>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>Riders</label>
                        <select class="form-control" v-model="selectedRiderId">
                            <option value="0" disabled>Select Rider</option>
                            <option  v-for="rider in riders" v-bind:key="'rider_'+rider.id" v-bind:value="rider.id">{{rider.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" :disabled="selectedRiderId===''" v-on:click="assignRider()"  class="btn btn-primary">Assign</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AssignRider",
        data: function () {
            return {
                riders:{},
                selectedRiderId:'',
                order:{},
            }
        },
        mounted: function () {
            $("#assignRiderModal").on('hidden.bs.modal',  (e) => {
                Object.assign(this.$data, this.$options.data.call());
            });     
        },
        methods: {
            load: function(order, modalRef){
                this.modalRef= modalRef;
                this.order= order;
                let params= new URLSearchParams();
                params.append("branch_id", this.order.branchesByBranchId.id)
                params.append("contact_verified", "true")
                this.$http.post(this.$store.state.mainAppURL + "restaurants/get_riders_of_branch", params).then(resp=>{
                    console.log(resp.data);
                    this.riders= resp.data;
                }).catch(ex => {
                    this.showErrorMessage(ex);
                })
                $("#assignRiderModal").modal("show");
            },
            assignRider: function(){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });                
                let params= new URLSearchParams();
                params.append("order_id", this.order.id);
                params.append("rider_id", this.selectedRiderId);
                this.$http.put(this.$store.state.mainAppURL + "orders/update_rider_in_order_object", params).then(resp=>{
                    Swal.close();
                    swal("Assigned!" ," Rider Has Been Assigned", "success");
                    $("#assignRiderModal").modal("hide");
                    $("#order_view_model").modal("hide");
                })
            }
        }
    }
</script>

<style scoped>

</style>